import { loadStripe } from '@stripe/stripe-js';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import env from '../../config/env';
import { useAxios } from '../../utils/hook/useAxios';
import { useUser } from '../../utils/hook/UserContext';

const stripePromise = loadStripe(env.stripePublicKey);
const StatusIcon = ({ isValid }) => {
  return isValid ? (
    <i className="bi bi-check-circle-fill h5 text-success"></i>
  ) : (
    <i className="bi bi-x-circle-fill h5 text-danger"></i>
  );
};

function OnboardingCheckout() {
  const [clientSecret, setClientSecret] = useState('');
  const [AmountPayed, setAmountPayed] = useState(347.0);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const axios = useAxios();

  const { user, loading, isAuthenticated } = useUser();

  // Récupérer les valeurs des paramètres
  const action = searchParams.get('action');
  const endDate = searchParams.get('endDate');
  const startTime = searchParams.get('startTime');
  const startDate = searchParams.get('startDate');
  const endTime = searchParams.get('endTime');
  const vehiculeId = searchParams.get('vehicleId');
  const NombreJour = searchParams.get('NombreJour');
  const priceU = searchParams.get('priceU');
  const fraisVoyage = searchParams.get('fraisVoyage');
  const TVA = searchParams.get('TVA');
  const Reduction = searchParams.get('Reduction');
  const FreeMinDistance = searchParams.get('FreeMinDistance');
  const vehiculeAnnonceId = searchParams.get('annonceId');
  const preavis = searchParams.get('preavis');
  const tampo = searchParams.get('tampo');
  const [VehiculeData, setVehiculeData] = useState(null);

  useEffect(() => {
    // Create PaymentIntent as soon as the page loads
    // fetch(`${BASE_URL_API}/api/create-payment-intent`, {
    //   method: "POST",
    //   headers: { "Content-Type": "application/json" },
    //   body: JSON.stringify({ amount: AmountPayed }),
    // })
    //   .then((res) => res.json())
    //   .then((data) => setClientSecret(data.clientSecret));

    axios
      .get('/vehicles/searchbyid/' + vehiculeId)

      .then((response) => {
        setVehiculeData(response.data);
      })
      .catch((error) => console.log(error));
  }, []);

  const appearance = {
    theme: 'stripe',
  };
  const options = {
    clientSecret,
    appearance,
  };

  function handleContinuer() {
    let dateTimeString = `${endDate}T${endTime}:00`;
    let date = new Date(dateTimeString);

    // Ajouter les heures du tampo
    date.setHours(date.getHours() + parseInt(tampo));

    // Formater la nouvelle date et heure
    let newDate = date.toISOString().split('T')[0];
    let newTime = date.toTimeString().split(' ')[0];
    (() => {
      axios
        .post('/reservations', {
          driverHoteId: VehiculeData.UserProfile.id,
          driverInviteId: user?.id,
          vehiculeId: vehiculeId,
          vehiculeAnnonceId: vehiculeAnnonceId,
          startDate: `${startDate} ${startTime}:00`,
          endDate: `${newDate} ${newTime}`,
          PaymentIntentId: null,
        })

        .then((response) => {
          (() => {
            axios
              .post('/conversations', {
                authorDriverRole: 1,
                driversId: VehiculeData.UserProfile.id,
                sentTime: new Date(),
                reservationId: response.data.reservationId,
                message: personnalisedMessage || 'Nouvelle demande de réservation',
              })

              .then((response) => {
                window.location.href =
                  `${env.baseUrlApi}/guest/reservation/` + response.data.reservationId;
              })

              .catch((error) => console.log(error));
          })();
        })
        .catch((error) => console.log(error));
    })();
  }

  const [personnalisedMessage, setPersonnalisedMessage] = useState(null);

  return (
    <>
      <main>
        <section class="mb-3">
          <div class="container col-md-6 w-md-50  border rounded-3 py-4">
            <h1 className="mb-3">
              <strong>Devenez un conducteur vérifié</strong>
            </h1>
            <p>
              Comme il s’agit de votre premier voyage, vous devez fournir certaines informations
              avant de pouvoir finaliser la transaction.
            </p>
            <hr />

            <div className="d-flex justify-content-between w-100">
              <p className="h5">Vérifier votre messagerie</p>
              <div>
                {' '}
                <i class="bi bi-check-circle-fill h5 text-success"></i>
              </div>
            </div>
            <p className="small">
              Nous avons envoyer un lien de vérification à{' '}
              <span className="text-primary"> {user.email}.</span> Veuillez cliquer le lien pour
              continuer le paiment
            </p>
            <hr />
            <div className="d-flex justify-content-between w-100">
              <p className="h5">Photo de profil</p>
              <StatusIcon isValid={Boolean(user.profile_url?.length)} />
            </div>
            <hr />
            <div className="d-flex justify-content-between w-100">
              <p className="h5">Numéro de mobile</p>
              <StatusIcon isValid={Boolean(user.phoneNumber?.length)} />
            </div>
            <hr />
            <div className="d-flex justify-content-between w-100">
              <p className="h5">Permis de conduire</p>
              <StatusIcon isValid={user.PermisConduire} />
            </div>
            <hr />

            <div class="alert alert-primary" role="alert">
              <i class="bi bi-chat-right-dots-fill h5"></i> Pour continuer. Assurez-vous d'avoir
              complèter votre profil
            </div>

            <button
              className="btn btn-tertiary w-100"
              data-bs-toggle="modal"
              data-bs-target="#reservationModalMobile"
            >
              Continuer
            </button>
            <div
              class="modal fade"
              id="reservationModalMobile"
              tabindex="-1"
              aria-labelledby="reservationModalMobileLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="reservationModalMobileLabel">
                      Confirmation de Réservation
                    </h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div class="modal-body">
                    Vous pouvez envoyer un message au propriétaire et confirmer la demande de
                    réservation (facultatif).
                  </div>
                  <div class="mb-3 p-1">
                    <textarea
                      class="form-control"
                      id="message"
                      rows="4"
                      placeholder="Entrez votre message ici..."
                      onChange={(e) => setPersonnalisedMessage(e.target.value)}
                      value={personnalisedMessage}
                    ></textarea>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-danger" data-bs-dismiss="modal">
                      Annuler
                    </button>
                    <button type="button" class="btn btn-lg text-white" onClick={handleContinuer}>
                      Confirmer
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default OnboardingCheckout;
